import React from 'react';
import PropTypes from 'prop-types';
import { getResizedImageUrl } from '@wix/wix-vod-shared/common';

const POSTER_SIZE = {
  width: 1080,
  height: 1600,
};

export class VideoPoster extends React.Component {
  static propTypes = {
    posterUrl: PropTypes.string,
    className: PropTypes.string,
  };

  render() {
    const { posterUrl, className } = this.props;

    if (!posterUrl) {
      return false;
    }

    const resizedPosterUrl = getResizedImageUrl({
      url: posterUrl,
      width: POSTER_SIZE.width,
      height: POSTER_SIZE.height,
    });

    return (
      <img
        alt=""
        className={className}
        data-hook="video-poster"
        aria-hidden="true"
        src={resizedPosterUrl}
      />
    );
  }
}
